const typeDict = {
  0: 'Текст',
  1: 'Файлы',
  2: 'Скриншот',
  3: 'Копия файла',
};

export const type = (val) => typeDict[val];
